import React, { useState, useEffect } from "react";
import styled from "styled-components";
import SpinnerMini from "../../interface/SpinnerMini";

const Container = styled.div`
  display: inline-block;
`;

const Toggle = styled.div`
  position: relative;
  height: 6em;
  width: 6em;

  .button {
    transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
    box-shadow: var(--shadow-btn-round);
    border-radius: 3em;
    position: absolute;
    background: var(--color-grey-main);
    margin-left: -29.4px;
    margin-top: -29.4px;
    display: block;
    height: 5em;
    width: 5em;
    left: 50%;
    top: 50%;
    cursor: pointer;

    &:active {
      filter: blur(0.5px);
      box-shadow: var(--shadow-btn-active);
    }
  }
`;

const IconWrapper = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 0; // To remove any extra space around the icon
`;

const Icon = styled.span`
  position: absolute;
  transition: color 300ms ease-out;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 0;
  position: absolute;
  font-weight: 700;
  font-size: 2.2em;
  opacity: 0.9;
  color: var(--color-grey-600);
`;

const MobileButtonRound = ({ children, onClick, resetDelay = 3000 }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleToggle = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), resetDelay);
  };

  useEffect(() => {
    if (onClick && isLoading) {
      onClick();
    }
  }, [isLoading, onClick]);

  return (
    <Container>
      <Toggle onClick={handleToggle}>
        <span className="button" />
        <Icon>{isLoading ? <SpinnerMini /> : children}</Icon>
      </Toggle>
    </Container>
  );
};

export default MobileButtonRound;
